jQuery(function ($) {

    /*
    * Add Lines to mobile nav
    -----------------------------------------------------*/
    // Info: Script is located in the divi Theme-Options body code Field

    /*
    * Navigation functionality enhancements
    -----------------------------------------------------*/
    function enhanceNav(){
        jQuery(function ($) {
            // Open sub-menu
            var menuItems = $("body ul.et_mobile_menu li.menu-item-has-children");
            // var menuItemLinks = $("body ul.et_mobile_menu li.menu-item-has-children > a");
           
            menuItems.each(function(){
                var menuLink = $(this);
                var menuLinkIcon = $("<div class='toggle-sub-menu'></div>");
                menuLink.append(menuLinkIcon);

                menuLinkIcon.on("click", function(e){
                    e.stopPropagation();  

                    if (menuLink.hasClass("is-open")) {
                        menuLink.removeClass("is-open");
                    } else {
                        $("li.menu-item-has-children.is-open").removeClass("is-open");
                        menuLink.addClass('is-open');
                    }
                });
            });
            
            // menuItems.on("click", function () {
            //     if ($(this).hasClass("is-open")) {
            //         $(this).removeClass("is-open");
            //     } else {
            //         $("li.menu-item-has-children.is-open").removeClass("is-open");
            //         $(this).addClass('is-open');
            //     }
            // });
     
             // Open current submenu
             $(".current-menu-parent").addClass('is-open');
     
             // Class for body indicating nav open status
             $(".mobile_menu_bar").on("click", function (event) {
                 // Add class for main nav open to body
                 $("body").toggleClass('nav-is-open');
             });
        });
    }
    enhanceNav();

    /*
    * Nav on-scroll changes 
    -----------------------------------------------------*/
    function navScrollChange(){
        $(window).on("scroll", function () {

            var scrollPos = $(window).scrollTop();
            var scrollMin = 1;
            
            if (scrollPos >= scrollMin) {
                $(".navigation__container").addClass("scrolled");
            }
            else {
                $(".navigation__container").removeClass("scrolled");
            }
        });
        $(window).trigger("scroll");
    }
    navScrollChange();
});